import { View } from "./Templates.view";

export const Container = () => {
  return <View />;
};
